module.exports = __webpack_public_path__ + "static/breakout_alt-f8a1b49ab4aae03781b24d148f6a43ed.jpg";